export enum UserLanguage {
	EN = "EN",
	DE = "DE",
}
